import React from "react";

const btnStyle = {
  width: "91px",
  height: "36px",
  padding: "8px, 11px, 8px, 11px",
  borderRadius: "8px",
  gap: "10px",
  background: "#FFFFFF",
  fontSize: "14px",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  fontWeight: "650",
  color: "#333",
  cursor: "pointer",
};
const activeTabStyle = {
  background: "#00B0F5",
  color: "#FFFFFF",
};
const disabledStyle = {
  background: "#EDEDED",
  color: "#333",
  cursor: "default",
};

const SelectFilterChip = ({
  selectedFilter,
  setSelectedFilter,
  disabled = false,
  isHideSingle = false,
  cb = () => {},
}) => {
  // const { selectedFilter, setSelectedFilter } = useGetDlpModuleContext();
  return (
    <div className="d-flex gap-md my-3">
      {!isHideSingle && (
        <div
          style={{
            ...btnStyle,
            ...(selectedFilter === "SINGLE" ? activeTabStyle : {}),
            ...(disabled ? disabledStyle : {}),
          }}
          onClick={() => {
            setSelectedFilter("SINGLE");
            cb();
          }}
        >
          Single
        </div>
      )}
      <div
        style={{
          ...btnStyle,
          ...(selectedFilter === "MASTER" ? activeTabStyle : {}),
          ...(disabled ? disabledStyle : {}),
        }}
        onClick={() => {
          setSelectedFilter("MASTER");
          cb();
        }}
      >
        Bulk
      </div>
    </div>
  );
};

export default SelectFilterChip;
